/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * マニュアル
 * @export
 * @interface ManualRow
 */
export interface ManualRow {
    /**
     * マニュアルID
     * @type {number}
     * @memberof ManualRow
     */
    id: number;
    /**
     * マニュアル表示名
     * @type {string}
     * @memberof ManualRow
     */
    name: string;
    /**
     * 公開日時
     * @type {string}
     * @memberof ManualRow
     */
    publishedAt: string;
}

export function ManualRowFromJSON(json: any): ManualRow {
    return ManualRowFromJSONTyped(json, false);
}

export function ManualRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'publishedAt': json['published_at'],
    };
}

export function ManualRowToJSON(value?: ManualRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'published_at': value.publishedAt,
    };
}


